import React from "react";

import EditIcon from "react-icons/lib/fa/edit";
import DeleteIcon from "react-icons/lib/fa/trash";

import { Flex, Link } from "src/components";
import { defaultPrevented } from "src/utils";

const iconsByName = {
  edit: EditIcon,
  delete: DeleteIcon,
};

const MenuItem = ({
  first,
  to = "#",
  color = "blue",
  onClick,
  disabled,
  title,
  iconName,
  Icon = iconName ? iconsByName[iconName] : undefined,
}) => (
  <Link
    to={to}
    onClick={disabled ? defaultPrevented(() => {}) : onClick}
    fontSize={3}
    fontWeight="semibold"
    textDecoration="none"
    py={2}
    px={2}
    borderWidth={first ? 0 : 1}
    borderTop={true}
    borderColor="divider"
    color={color}
    disabled={disabled}
  >
    <Flex align="center">
      {Icon ? (
        <Flex mr={1}>
          <Icon size={16} />
        </Flex>
      ) : null}
      {title}
    </Flex>
  </Link>
);

export default MenuItem;



// WEBPACK FOOTER //
// ./src/banking/components/Menu/MenuItem.js